<template>
  <b-container class="py-3" id="license">
    <custom-section source="License/FAQ"/>
    <custom-section source="License/Legal"/>
  </b-container>
</template>
<script>
  import CustomSection from './CustomSection';

  export default {
    components: {CustomSection},
  };
</script>
<style lang="scss">
  #license {
    h6 {
      font-style: italic !important;
    }
  }
</style>
